import gql from "graphql-tag";

export default gql`
  query PerEmployeeRatiosHistory($tickerSymbol: TickerSymbol!) {
    perEmployeeRatiosHistory(tickerSymbol: $tickerSymbol) {
      asOfDate
      totalOfEmployees
      netIncomePerFullTimeEmployee
      revenuePerEmployee
    }
  }
`;
